<template>
  <a class="next-button"><img src="~@/assets/arrow.png" /></a>
</template>

<script>
export default {
  name: 'next-button'
}
</script>

<style lang="scss" scoped>
  .next-button {
    background: #F98B02;
    border-radius: 100%;
    bottom: 29px;
    display: inline-block;
    height: 47px;
    position: absolute;
    right: 29px;
    width: 47px;
  }
  img {
    height: 23px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 29px;
  }

</style>
